import { render } from "./MyProjects.vue?vue&type=template&id=4798dc96&scoped=true"
import script from "./MyProjects.vue?vue&type=script&lang=js"
export * from "./MyProjects.vue?vue&type=script&lang=js"

import "./MyProjects.vue?vue&type=style&index=0&id=4798dc96&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4798dc96"]])

export default __exports__